<template>
  <div class="view-trip">
    <vue-scroll :ops="scrollBar">
      <div v-if="Object.keys(booking).length != 0">
        <googleMap
          :addressCallback="addressCallback"
          placeholder="Search from"
          :style="{'width':'100%'}"
          :data="booking"
        />
        <div :style="{'padding': '20px'}">
        <b-row>
          <b-col cols="6"><b-badge pill variant="primary" style="font-size: 16px;padding: 5px;">${{ (typeof booking.totals !== 'undefined' && typeof booking.totals.riderAmount !== 'undefined') ? booking.totals.riderAmount / 100 : booking.fareEstimate / 100 }}</b-badge></b-col>
          <b-col cols="6" :style="{'text-align':'right'}"><b-badge pill variant="secondary" style="padding: 8px;">{{getBookingStatus(booking.updateStatus.status)}} / {{getBookingAction(booking.updateStatus.action)}}</b-badge></b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="text-center">
            <h5>Pick up</h5>
            {{ booking.startLoc.address }}
          </b-col>
          <b-col cols="12" class="text-center">
            <font-awesome-icon
              icon="arrow-alt-circle-down"
              :style="{'margin': '15px 0 0 0','font-size':'20px'}"
            />
          </b-col>
          <b-col cols="12" class="text-center">
            <h5>Drop off</h5>
            {{ booking.endLoc.address }}
          </b-col>
          <b-col cols="4" class="text-center" :style="{'margin': '10px 0 0 0'}">
            <h5>Pickup</h5>
            {{ formatDate(booking.pickupTs) }}
          </b-col>
          <b-col cols="4" class="text-center" :style="{'margin': '10px 0 0 0'}">
            <h5>Dropoff</h5>
            {{ formatDate(booking.dropoffTs) }}
          </b-col>
          <b-col
            cols="4"
            v-if="(typeof booking.schedule !== 'undefined') ? true : false"
            class="text-center"
            :style="{'margin': '10px 0 0 0'}"
          >
            <h5>Scheduled date</h5>
            {{ formatDate(booking.schedule) }}
          </b-col>
          <b-col cols="12">
            <hr />
          </b-col>
          <b-col cols="6">
            <h5>Driver</h5>
            {{ (typeof booking.driver !== 'undefined') ? booking.driver.firstName : '' }}{{ (typeof booking.driver !== 'undefined') ? ` ${booking.driver.lastName}` : '' }}
            <h5>Vehicle</h5>
            {{ (typeof booking.car !== 'undefined' && typeof booking.car.colour !== 'undefined') ? booking.car.colour : '' }}{{ (typeof booking.car !== 'undefined' && typeof booking.car.make !== 'undefined') ? ` ${booking.car.make}`: '' }}{{ (typeof booking.car !== 'undefined' && typeof booking.car.model !== 'undefined') ? ` ${booking.car.model}` : '' }}
            <h5>Plate Number</h5>
            {{ (typeof booking.car !== 'undefined' && typeof booking.car.plateNumber !== 'undefined') ? booking.car.plateNumber : '' }}
          </b-col>
          <b-col cols="6">
            <h5>Driver Number</h5>
            {{ (typeof booking.driver !== 'undefined') ?  [1,2].indexOf(booking.status) != 1 ? booking.driver.phone:'' : '' }}
            <h5>Passenger Name</h5>
            {{ getmetadata(booking, 'passengerName') }}
            <h5>Passenger Number</h5>
            {{ getmetadata(booking, 'passengerNumber') }}
          </b-col>
          <b-col cols="12">
            <hr />
          </b-col>
          <b-col cols="12">
            <h5>Passenger tripNotes</h5>
            <div v-html="getNotes(booking)"></div>
          </b-col>
          <b-col cols="12" v-if="[4,6].indexOf(booking.status) == -1">
            <b-button @click="cancelBooking" variant="danger">Cancel Booking</b-button>
          </b-col>
        </b-row>
        <b-row v-if="displayRatingForm">
          <b-col cols="12">
            <hr />
            <h4>Give stars</h4>
            <star-rating :star-size="25" rating="5" v-model="ratingStars" />
          </b-col>
          <b-col cols="12">
            <h4>Notes</h4>
            <b-form-textarea
              id="textarea"
              v-model="rateNotes"
              placeholder="How was the trip..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-col>
          <b-col cols="12" :style="{'margin':'10px 0 0 0'}">
            <b-button @click="rateTrip" variant="primary" :disabled="rateTripBtnPress">Rate Trip<b-spinner small v-if="rateTripBtnPress"></b-spinner></b-button>
          </b-col>
        </b-row>
        </div>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
import shebahApi from "@/services/shebah/index";
import { googleMap } from "@/components/google/index";
import StarRating from "vue-star-rating";
import moment from "moment";

export default {
  name: "viewBooking",
  components: {
    googleMap,
    StarRating
  },
  props: {
    bookingId: String,
    openBooking: Boolean,
    closePreview: Function
  },
  computed: {
    scrollBar() {
      return this.$store.getters["general/scrollbar"];
    }
  },
  data() {
    return {
      booking: {},
      tripInterval: null,
      componentBookingId: null,
      ratingStars: 5,
      rateNotes: "",
      canNotRateTrip: true,
      displayRatingForm: false,
      rateTripBtnPress: false,
      noUpdateStatus: [4,6]
    };
  },
  watch: {
    openBooking() {
      if (this.openBooking) {
        this.openModal();
      }
    },
    ratingStars() {
      if (this.ratingStars > 1) {
        this.canNotRateTrip = false;
      } else {
        this.canNotRateTrip = true;
      }
    }
  },
  created() {
    // this.bookingId = this.bookingId;
  },
  beforeDestroy() {
    this.close();
  },
  methods: {
    async openModal() {
      this.booking = {};
      clearInterval(this.tripInterval);
      await this.getBooking();
      if (this.noUpdateStatus.indexOf(this.booking.status) == -1) {
        this.tripInterval = setInterval(async () => {
          await this.getBooking();
          if (this.noUpdateStatus.indexOf(this.booking.status) != -1) {
            clearInterval(this.tripInterval);
          }
        }, 5000);
      }
    },
    async getBooking() {
      this.displayRatingForm = false;
      this.booking = await shebahApi.api.bookings.get(this.bookingId);

      if (
        typeof this.booking.riderReview === "undefined" &&
        this.booking.status == 6
      ) {
        this.displayRatingForm = true;
      }
    },
    async rateTrip() {
      this.rateTripBtnPress = true;
      this.booking = await shebahApi.api.bookings.rateBooking(this.bookingId, {
        review: {
          rating: this.ratingStars,
          comment: this.rateNotes
        }
      });
      this.displayRatingForm = false;
      this.rateTripBtnPress = false;
    },
    addressCallback(result) {},
    getBookingStatus(status) {

      let statusEnum = {
        1: "New",
        2: "Assigned",
        3: "On Route",
        4: "Cancelled",
        5: "In Transit",
        6: "Completed",
        7: "Advanced",
        8: "Pending Payment"
      };

      return typeof statusEnum[status] !== "undefined"
        ? statusEnum[status]
        : "";
    },
    getBookingAction(action) {

      let actionEnum = {
        10: "Rider Created",
        11: "Rider Cancel",
        12: "Rider Update Location",
        20: "Driver Accept",
        21: "Driver Decline",
        22: "Driver Cancel",
        23: "Driver Pick Up",
        24: "Driver Drop Off",
        25: "Driver Start",
        30: "System Assign",
        31: "System Cancel",
        32: "Insufficient Funds",
        33: "Split Fare"
      };

      return typeof actionEnum[action] !== "undefined"
        ? actionEnum[action]
        : "";
    },
    getmetadata(booking, key) {
      if (typeof booking.metadata !== "undefined") {
        for (let matakey in booking.metadata) {
          let metadata = booking.metadata[matakey];
          if (metadata.key === key) {
            return metadata.value;
          }
        }
        return "";
      }
    },
    async cancelBooking() {
      await shebahApi.api.bookings.cancelBooking(this.bookingId);
    },
    close() {
      if (typeof this.closePreview !== "undefined") {
        this.closePreview();
        clearInterval(this.tripInterval);
        setTimeout(() => {
          this.booking = {};
        }, 100);
      }
    },
    formatDate(date) {
      let formatDate = "";
      if (typeof date !== "undefined") {
        formatDate = moment(date).format("DD-MM-YYYY HH:mm:ss");
      }
      return formatDate;
    },
    getNotes(booking) {
      let tripNotes = this.getmetadata(booking, "tripNotes");
      let notes = "";
      if (typeof booking.notes === "undefined") {
        notes = tripNotes;
      } else {
        notes = booking.notes;
      }

      return notes.replace(/\n/g, "<br />");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.view-trip {
  height: 100%;
}
</style>
